import { FC, useState, useEffect, useContext } from "react";
import KickImage from 'Reuseables/KickImage';
import moment from "moment";

//Components
import Component from "./Component";

//Actions
import { getOrderDetails } from "../../../../actions/shipperAction";

//Helpers
import { momentHandler, dateHandler as dateHandlerHelpers, formatCurrency } from "../../../../utils/Helpers";

//Interfaces
import { OrderDetailsInterface } from "../definitions";
import { WrapperInterface } from "./definitions";

const Wrapper: FC<WrapperInterface> = ({
  onCancel,
  onPickupDetails,
  order_id
}) => {
  const [loading, setLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState<OrderDetailsInterface | null>(null);

  const { origin, pickup_time, time_slot_selected } = orderDetails || {};
  const { address, city_name, province_name, suburb_name, postcode } = origin || {};
  const { start_time, end_time } = time_slot_selected || {};

  const getOrderDetailsHandler = async (order_id) => {
    try {
      setLoading(true)
      await getOrderDetails(order_id)
        .then(res => res?.data)
        .then(res => {
          if (!res.data) return;
          let _orderDetail = { ...res.data }

          if (!_orderDetail.time_slot_selected?.start_time) {
            let _timeslot = localStorage.getItem(`${order_id}_TIMESLOT`)
            _timeslot && (_timeslot = JSON.parse(_timeslot))
            _orderDetail = { ..._orderDetail, time_slot_selected: _timeslot }

          } else {
            localStorage.removeItem(`${order_id}_TIMESLOT`)
          }

          setOrderDetails(_orderDetail)
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })

    } catch (err) {
      setLoading(false)
      console.log(err, "Err when fetching order details")
    }
  }

  const refreshHandler = () => getOrderDetailsHandler(order_id);
  
  // Components Handler
  const dayHandler = () => {
    try {
      if (moment(start_time).isSame(start_time, "day")) return "Today";
      return momentHandler(start_time, 'dddd');
    } catch (err) {
      console.log(err, "Error when parsing hours fn dayHandler file PikcupScheduledDetails.tsx")
      return ""
    }
  }
  const hoursHandler = () => {
    try {
      const start_hour = momentHandler(start_time, 'HH:MM');
      const end_hour = momentHandler(end_time, 'HH:MM');

      return <span>{start_hour} - {end_hour}</span>
    } catch (err) {
      console.log(err, "Error when parsing hours fn hoursHandler file PikcupScheduledDetails.tsx")
      return <span></span>
    }
  }
  const dateHandler = () => {
    try {
      const date = momentHandler(start_time, 'Do');
      const _date = dateHandlerHelpers(date)

      return <span className="date">{_date[0]}<span className="suffix">{_date[1]}</span></span>
    } catch (err) {
      console.log(err, "Error when parsing hours fn dateHandler file PikcupScheduledDetails.tsx")
      return <span></span>
    }
  }

  const monthHandler = () => momentHandler(start_time, 'MMM');
  const yearHandler = () => momentHandler(start_time, 'YYYY');

  //Use effect
  useEffect(() => {
    getOrderDetailsHandler(order_id)
  }, [])

  return (
    <Component
      loading={loading}
      order_id={order_id}
      address={address}
      suburb_name={suburb_name}
      city_name={city_name}
      province_name={province_name}
      postcode={postcode}
      refreshHandler={refreshHandler}
      renderDay={dayHandler()}
      renderDate={dateHandler()}
      renderMonth={monthHandler()}
      renderYear={yearHandler()}
      renderHours={hoursHandler()}
      onCancel={onCancel}
      onPickupDetails={onPickupDetails}
    />
  )
}
export default Wrapper;